import { render, staticRenderFns } from "./laobinguserlist.vue?vue&type=template&id=51c911da&scoped=true&"
import script from "./laobinguserlist.vue?vue&type=script&lang=js&"
export * from "./laobinguserlist.vue?vue&type=script&lang=js&"
import style0 from "./laobinguserlist.vue?vue&type=style&index=0&id=51c911da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c911da",
  null
  
)

export default component.exports